import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  <path
    transform='translate(-3 -3)'
    d='M19.42 9.165a3.5 3.5 0 113.58 1.8v8.07A3.5 3.5 0 1119.035 23h-8.07a3.5 3.5 0 11-1.8-3.58L19.421 9.166zm1.415 1.414L10.579 20.835c.03.054.058.11.084.165h8.674A3.514 3.514 0 0121 19.337v-8.674a3.488 3.488 0 01-.165-.084zM22.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-15 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'
  />,
  'PolygonGeofence'
);

const PolygonGeofenceIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(PolygonGeofenceIcon);
